export default class GoogleLoginHandler{
    constructor() {
        var googleButtons = document.querySelectorAll('[data-container="login-google"]');
        var googleButtonsHidden = document.querySelectorAll('[name="google-login-hidden"] [role="button"]');
        if (!googleButtons || !googleButtonsHidden || !(googleButtons.length === googleButtonsHidden.length)) return;
        googleButtons.forEach( (googleButton, index) => {
            googleButton.addEventListener('click',() => {
                googleButtonsHidden[index].click();
            })
        });
    }
}
